export default {
  shopName: '店铺名称',
  uploadStoreLogo: '上传店铺Logo',
  shopType: '店铺类型',
  countrySite: '店铺基于国家站点',
  basicMarketplace: '市场基站',
  typeB: '专业店',
  typeC: '基础店',
  typeA: 'A类店铺',
  storeTypeB: '品牌店',
  shopQualification: '店铺资质',
  useMerchantQualification: '使用主商户资质',
  useNewQualification: '使用新商户资质',
  companyName: '企业名称',
  registerCode: '注册号',
  location: '所在地',
  companyUpload: '上传营企执照照片',
  createShopSuccess: '创建店铺成功',
  ruleMsgShopName: '请检查店铺名',
  ruleMsgRegisterCode: '请检查注册号',
  ruleMsgShopType: '请选择店铺类型',
  ruleMsgShopQualification: '请选择店铺资质',
  ruleMsgNoLogo: '请上传logo',
  ruleMsgOnlyOne: '只能上传一张logo',
  kilimall: 'Kilimall平台',
  marketPaymentAgreements: '市场支付相关协议',
  vatRegistered: '是否注册增值税税号(VAT)？',
  yes: '是',
  no: '否',
  vatNo: '增值税号',
  uploadStoreLogoTip: '请上传正方形白底图片，大小不超过 1 Mb',
  phone: '电话',
  contactsReceivingSys: '接收系统消息的联系方式',
  onlyEnglishAndNumber: '店铺名称只能是字母、数字和空格的组合',
  containSensitiveWords: '您店铺名称不能包含敏感词',
  storeNameExists: '您输入的店铺名已经被占用',
  requiredSettlementInfo: '您还未完整填写所有必要的结算信息',
  continueFilling: '继续填写必要信息',
  skipStep: '跳过此步，后续再补充'
}
